const c = {
  name: "Eye",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,9c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C24,10.8,22.2,9,20,9z M18,13c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C18.9,15,18,14.1,18,13z"/>
		<path class="st0" d="M11,13c0-5,4-9,9-9c5,0,9,4,9,9c0,5-4,9-9,9C15,22,11,18,11,13z M20,6c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7
			s7-3.1,7-7C27,9.1,23.9,6,20,6z"/>
		<path class="st0" d="M5,6.3C8.2,3.2,13.2,0,20,0s11.8,3.2,15,6.3c1.6,1.6,2.8,3.1,3.6,4.3c0.4,0.6,0.7,1.1,0.9,1.4
			c0.1,0.2,0.2,0.3,0.2,0.4c0,0,0,0.1,0.1,0.1l0,0l0,0l0,0c0,0,0,0-0.9,0.4c0.9,0.4,0.9,0.4,0.9,0.4l0,0l0,0l0,0c0,0,0,0.1-0.1,0.1
			c-0.1,0.1-0.1,0.2-0.2,0.4c-0.2,0.3-0.5,0.8-0.9,1.4c-0.8,1.2-2,2.7-3.6,4.3c-3.2,3.1-8.2,6.3-15,6.3S8.2,22.8,5,19.7
			c-1.6-1.6-2.8-3.1-3.6-4.3C1,14.8,0.7,14.4,0.5,14c-0.1-0.2-0.2-0.3-0.2-0.4c0,0,0-0.1-0.1-0.1l0,0l0,0l0,0l0,0c0,0,0,0,0.9-0.4
			c-0.9-0.4-0.9-0.4-0.9-0.4l0,0l0,0l0,0l0,0c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.4c0.2-0.3,0.5-0.8,0.9-1.4
			C2.2,9.4,3.4,7.8,5,6.3z M2.3,13c0.2,0.3,0.4,0.8,0.8,1.3c0.7,1.1,1.8,2.5,3.3,4c3,2.9,7.5,5.7,13.6,5.7s10.6-2.8,13.6-5.7
			c1.5-1.4,2.6-2.9,3.3-4c0.4-0.5,0.6-1,0.8-1.3l0,0l0,0c-0.2-0.3-0.4-0.8-0.8-1.3c-0.7-1.1-1.8-2.5-3.3-4C30.6,4.8,26.2,2,20,2
			S9.3,4.8,6.4,7.7c-1.5,1.4-2.6,2.9-3.3,4C2.7,12.2,2.4,12.7,2.3,13L2.3,13L2.3,13z"/>
		<path class="st0" d="M1.1,13l-0.9,0.4L0,13l0.2-0.4L1.1,13z"/>
		<path class="st0" d="M38.9,13l0.9-0.4L40,13l-0.2,0.4L38.9,13z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Eye
};
